module.exports = __webpack_public_path__ + "img/pgshiksha.d7d6f85f.jpeg";